import { Button } from '@/components/ui/button'
import { Pencil } from 'lucide-react'

interface Props {
  onClick: () => void
  className?: string
}

export default function CustomEditButton({ onClick, className }: Props) {
  return (
    <Button onClick={onClick} variant="window" size="sm" className={className}>
      <Pencil className="h-3 w-3" />
      Edit
    </Button>
  )
}
